import { Stack, type StackProps, Typography } from '@mui/material';
import { filterSdxIconToRedDark, InProgressError } from '@sodexo/ui-components';

type DataGridNoRowsOverlayProps = {
  title: string;

  // Determine if the user cannot access the data
  forbidden?: boolean;

  // The title to show when the user cannot access the data
  forbiddenTitle?: string;
} & StackProps;

export function DataGridNoRowsOverlay({ title, forbidden, forbiddenTitle, ...props }: DataGridNoRowsOverlayProps) {
  return (
    <Stack justifyContent='center' height='100%' alignItems='center' gap={2} {...props}>
      {forbidden ? (
        <>
          <InProgressError style={{ width: 60, height: 60, ...filterSdxIconToRedDark }} />
          <Typography align='center'>{forbiddenTitle}</Typography>
        </>
      ) : (
        <>
          <img alt='no results' style={{ maxHeight: 100 }} src='/images/ghost.svg' />
          <Typography align='center'>{title}</Typography>
        </>
      )}
    </Stack>
  );
}
